import React, { useState } from "react";
import cn from "classnames";
import st from "@/components/pages/blog/ai-article/common.module.scss";
import s from "./ArticleCategories.module.scss";

import { ArticleCategoriesModal } from "./ArticleCategoriesModal";
import { StrapiCategoryPreview } from "@/shared/types/strapi/collections/category";
import { StrapiArticleCondensedResponse } from "@/shared/types/strapi/collections/article";
import { ArticleCategoryItem } from "./ArticleCategoryItem";
import { ArticleCategoriesSearchModal } from "@/components/pages/blog/ai-article/components/ArticleCategoriesSearchModal";

export type ArticleCategoriesProps = {
  categories: StrapiCategoryPreview[];
  articlesData: StrapiArticleCondensedResponse;
  articlesTotalCount: number;
  idCategory: number;
  articleSlug?: string;
};

export const ArticleCategories = ({
  categories,
  articlesData,
  articlesTotalCount,
  idCategory,
  articleSlug,
}: ArticleCategoriesProps) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedIdCategory, setSelectedIdCategory] = useState<number>();

  const [categoryArticles, setCategoryArticles] = useState<
    Record<
      number,
      {
        data: StrapiArticleCondensedResponse;
        open: boolean;
      }
    >
  >({
    [idCategory]: {
      data: articlesData,
      open: true,
    },
  });

  const allCategories: StrapiCategoryPreview[] = categories.sort(
    (a, b) => (a.attributes.displayOrder || 0) - (b.attributes.displayOrder || 0)
  );

  const handleCategoryOpen = async (idCategory: number) => {
    setLoading(true);
    try {
      const resp = await (
        await fetch("/api/articles?idCategory=" + idCategory, {
          cache: "no-store",
        })
      ).json();

      setCategoryArticles({
        ...categoryArticles,
        [idCategory]: {
          data: resp,
          open: true,
        },
      });
    } catch (err) {}
    setLoading(false);
  };

  const handleCategoryShowAll = async (idCategory: number) => {
    setSelectedIdCategory(idCategory);
    setModalVisible(true);
  };

  return (
    <div className={cn(st.card, s.wrapper)}>
      <ArticleCategoriesSearchModal
        articlesTotalCount={articlesTotalCount}
        visible={modalVisible}
        onVisibleChange={setModalVisible}
        selectedIdCategory={selectedIdCategory}
        onSelectedCategoryChange={setSelectedIdCategory}
      />

      <div className={cn(s.categoriesWrap, { [s.isLoading]: loading })}>
        <div className={s.categories}>
          <ul>
            {allCategories.map(({ id, attributes: { slug, heading, sidebarTitle, articles } }) => (
              <ArticleCategoryItem
                key={id}
                idCategory={id}
                categorySlug={slug}
                title={sidebarTitle || heading}
                articlesData={categoryArticles[id]?.data}
                initiallyOpen={id === idCategory}
                articleSlug={articleSlug}
                onOpen={handleCategoryOpen}
                onShowAll={handleCategoryShowAll}
                hasArticles={!!articles?.data?.attributes?.count}
              />
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};
